import React from 'react';
import NmckFuelCalculation from '../../layout/NmckGroup/NmckFuelCalculation';
import PageLayout from '../../layout/PageLayout';

const NmckFuelCalculationPage: React.FC = () => (
  <PageLayout>
    <NmckFuelCalculation />
  </PageLayout>
);

export default NmckFuelCalculationPage;
